import type { FieldComponents } from '@/shared/components/form-fields/types';
import { FIELD_MAX_LENGTHS } from '@/shared/constants';
import { withForm } from '../../hooks/use-proposal-decision-form.hook';
import { DecisionAttachmentsField } from './decision-attachments-field.component';
import { decisionFormOpts } from './decision-form-options';

export const DecisionAcceptFields = withForm({
  ...decisionFormOpts,
  props: {},
  render: ({ form }) => (
    <>
      <form.AppField
        name='acceptance'
        children={(field: FieldComponents) => (
          <field.TextareaField
            label='Observações de aceitação'
            placeholder='Digite as observações sobre a aceitação da proposta'
            rows={5}
            maxLength={FIELD_MAX_LENGTHS.textarea}
          />
        )}
      />

      <DecisionAttachmentsField form={form} />
    </>
  ),
});
